import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, Outlet } from 'react-router-dom';
import VehicleList from './vehicleList';
import VehicleLogList from './views/vehicleLog/vehicleLog';
import DownloadFileList from './views/downloadFile/downloadFile';
import DispatchDownloadFileList from './views/dispatchDownloadFile/index';
import RouteWrapper from '../../../routing/RouterWrapper';

const VehicleWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/vehicle') {
      navigate('detail');
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="/" element={<WrapperWithOutlet />}>
        <Route path="detail" element={<RouteWrapper component={VehicleList} />} />
        <Route path=":vehicleId" element={<RouteWrapper component={VehicleLogList} />} />
        <Route path="file/Import" element={<RouteWrapper component={DownloadFileList} />} />
        <Route path="dispatch-file/Import" element={<RouteWrapper component={DispatchDownloadFileList} />} />
      </Route>
    </Routes>

  );
};

const WrapperWithOutlet = () => {
  return <Outlet />;
};

export default VehicleWrapper;
